import React, { useState } from 'react';
import { PauseIcon, PlayIcon } from 'lucide-react';
import { clientLogos } from '../../data/clientLogos';
import { getLogoBox, logoFilterId } from '../../utils/logoSizing';
import type { ClientLogo } from '../../types/logos';
const LABEL_ID = 'clients-label';
interface ClientLogoStripProps {
  /** Align the label with the headline column and drop the rule above the strip. */
  aligned?: boolean;
}
export function ClientLogoStrip({
  aligned = true
}: ClientLogoStripProps) {
  const [paused, setPaused] = useState(false);
  return <div className={`logo-marquee pb-10 md:pb-14 ${aligned ? 'pt-2 md:pt-4' : 'border-t border-fog pt-7 md:pt-8'}`} data-paused={paused} data-id="element-57" data-mp="3akd8axn2ukg7">
      <div className={`mx-auto max-w-page px-6 md:px-12 xl:px-20 ${aligned ? 'md:grid md:grid-cols-12 md:gap-8' : ''}`} data-id="element-58" data-mp="3jft7lu6lprt6">
        <p id={LABEL_ID} className={`whitespace-nowrap pt-[2px] font-mark text-[12px] uppercase tracking-label text-ridge ${aligned ? 'md:col-span-8 md:col-start-5' : ''}`} data-id="element-59" data-mp="2mwdfzta4alzi">
          40 yawgoo consulting is Trusted By
        </p>
      </div>

      <div className="relative mt-6 md:mt-8" data-id="element-60" data-mp="2ypav160iba56">
        <div className="overflow-hidden py-1" data-id="element-61" data-mp="2yqluitmx5vqh">
          <div className="logo-track" data-id="element-62" data-mp="2tykldgl1sl4o">
            <LogoSet labelledBy={LABEL_ID} data-id="element-63" data-mp="2txj1cmm20oat" />
            <LogoSet decorative data-id="element-64" data-mp="2tw7uuf1852g0" />
          </div>
        </div>
        <button type="button" onClick={() => setPaused(p => !p)} aria-label={paused ? 'Play logo scroll' : 'Pause logo scroll'} className="logo-pause absolute right-4 top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center border border-fog bg-paper text-ink transition-[border-color] duration-150 ease-quiet hover:border-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink md:right-8" data-id="element-65" data-mp="2oyojpnztp5sa">
          {paused ? <PlayIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.5} data-id="element-66" data-mp="9690j8d3qrvv" /> : <PauseIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.5} data-id="element-67" data-mp="475uplpashmu" />}
        </button>
      </div>
    </div>;
}
function LogoSet({
  labelledBy,
  decorative = false
}: {
  labelledBy?: string;
  decorative?: boolean;
}) {
  return <ul role="list" className="logo-set" aria-labelledby={decorative ? undefined : labelledBy} aria-hidden={decorative ? 'true' : undefined} data-id="element-68" data-mp="1os2mlh9f6t8c">
      {clientLogos.map(logo => <LogoItem key={logo.id} logo={logo} decorative={decorative} data-id="element-69" data-mp="2hh05nmlggu25" />)}
    </ul>;
}
function LogoItem({
  logo,
  decorative
}: {
  logo: ClientLogo;
  decorative: boolean;
}) {
  const box = getLogoBox(logo);
  return <li className="relative shrink-0 overflow-hidden" style={{
    width: `calc(var(--logo-scale) * ${box.width}px)`,
    height: `calc(var(--logo-scale) * ${box.height}px)`
  }} data-id="element-70" data-mp="27h9b5kwwaf22">
      <img src={logo.src} alt={decorative ? '' : logo.name} width={logo.width} height={logo.height} draggable={false} decoding="async" loading={decorative ? 'lazy' : 'eager'} className="pointer-events-none absolute max-w-none select-none" style={{
      ...box.image,
      objectFit: 'contain',
      filter: `url(#${logoFilterId(logo.id)})`
    }} data-id="element-71" data-mp="w4qak10vy3ta" />
    </li>;
}